import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

import { Button } from '.';
import { useStateContext } from '../contexts/ContextProvider';

const Language = () => {
  const { currentColor } = useStateContext();

  return (
    <div className="nav-item absolute right-5 md:right-10 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          <p className="font-semibold text-sm dark:text-gray-200">Select Language</p>
        </div>
        <Button icon={<MdOutlineCancel />} color="rgb(153, 171, 180)" bgHoverColor="light-gray" size="2xl" borderRadius="50%" />
      </div>
      <div className="">
      
        <div className="py-2 px-2 hover:cursor-pointer hover:bg-[#808080] hover:text-[#fff] transition duration-500 hover:scale-105">
          <p>English</p>
        </div>
        <div className="py-2 px-2 hover:cursor-pointer hover:bg-[#808080] hover:text-[#fff] transition duration-500 hover:scale-105">
          <p>French</p>
        </div>
      </div>
    </div>
  );
};

export default Language;
